import { useTranslation } from 'react-i18next';

import Tracked from '~/components/Tracked';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import { SelectedView } from './index';

type Props = {
  selectedView: SelectedView;
  setSelectedView: React.Dispatch<React.SetStateAction<SelectedView>>;
};

export default function ViewToggle({ selectedView, setSelectedView }: Props) {
  const { t } = useTranslation('pdp');
  const { RAFFLES, RETAILERS } = SelectedView;

  return (
    <div className="mb-2 flex gap-2">
      <Toggle
        isSelected={selectedView === RETAILERS}
        onClick={() => setSelectedView(RETAILERS)}
        name="WTB_VIEW_TOGGLE_RETAILERS"
      >
        {t('retailers')}
      </Toggle>
      <Toggle
        isSelected={selectedView === RAFFLES}
        onClick={() => setSelectedView(RAFFLES)}
        name="WTB_VIEW_TOGGLE_RAFFLES"
      >
        {t('raffles')}
      </Toggle>
    </div>
  );
}

function Toggle({
  onClick,
  children,
  isSelected,
  name
}: {
  children: React.ReactNode;
  isSelected: boolean;
  name: TrackedButtonClickName;
  onClick: () => void;
}) {
  return (
    <Tracked.Button
      onClick={onClick}
      className={`!rounded-full py-2 ${isSelected ? 'bg-black text-white' : ''}`}
      pagePosition="WTB"
      name={name}
      variant={
        isSelected ? 'transparent-black-border' : 'transparent-grey-border'
      }
    >
      <p className="flex items-center justify-center gap-1 text-sm font-normal">
        {children}
      </p>
    </Tracked.Button>
  );
}
